import React from 'react';
import { Tag } from 'primereact/tag';
import { Status } from '../types';
import { kanbanColorMap } from '../../../../constants';

interface StatusTagProps {
    status: Status;
}


const getStatusSeverity= (status: Status) => {
    switch (status) {
        case 'Done':
            return kanbanColorMap.get('Done');
        case 'To Do':
            return kanbanColorMap.get('To Do');
        case 'Needs Help':
            return kanbanColorMap.get('Needs Help');
        case "In Progress":
            return kanbanColorMap.get('In Progress');
        default:
            return undefined;
    }
};

export const StatusTag = ({status}:StatusTagProps) => {
    return <Tag value={status} style={{backgroundColor:getStatusSeverity(status),color:"#fff"}}/>;
};
